module.exports = __webpack_public_path__ + "src/assets/img/circles-bg.046ef6f8.png";